var map = {
	"./de.json": 1969,
	"./en.json": 1970,
	"./es-ES.json": 1971,
	"./es.json": 1972,
	"./fr.json": 1973,
	"./it.json": 1974,
	"./ja.json": 1975,
	"./nl.json": 1976,
	"./pt.json": 1977,
	"./ru.json": 1978,
	"./yy.json": 1979,
	"./zh-CN.json": 1980
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 3);
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 1968;
module.exports = webpackAsyncContext;